<template>
  <dx-modal :value="show"
            title="Receber no caixa"
            size="xl"
            @input="close()"
            id="modal-cash-register-receive">
    <receive ref="receive"
             :appointment-ids="appointmentIds"
             embedded
             @state="state = $event"
             @done="onDone"/>
    <template slot="footer">
      <button class="btn btn-primary btn-icon btn-icon-left mr-1"
              v-if="state.editing"
              :class="{loading: state.saving}"
              :disabled="state.saving || !state.canFinish"
              @click="$refs.receive.conclude()">
        <fa-icon :icon="['fal', 'check']"/>{{ state.label }}
      </button>
      <template v-if="state.done">
        <button class="btn btn-primary btn-icon btn-icon-left mr-1"
                :class="{loading: state.printing}"
                :disabled="state.printing"
                @click="$refs.receive.printReceipt()">
          <fa-icon :icon="['fal', 'print']"/>Recibo
        </button>
        <button class="btn btn-secondary btn-icon btn-icon-left mr-1"
                v-if="state.canIssueInvoice"
                :disabled="state.invoiceLoading"
                @click="$refs.receive.openInvoice()">
          <fa-icon :icon="['fal', 'file-invoice-dollar']"/>Emitir NFS-e
        </button>
      </template>
      <button class="btn" @click="close()">Sair</button>
    </template>
  </dx-modal>
</template>

<script>
import Receive from '../components/Receive.vue';

export default {
  components: {
    Receive,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    appointmentIds: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      entry: null,
      state: {
        editing: false,
        canFinish: false,
        saving: false,
        label: 'Finalizar recebimento',
        done: false,
        printing: false,
        canIssueInvoice: false,
        invoiceLoading: false,
      },
    };
  },
  methods: {
    onDone(entry) {
      this.entry = entry;
      this.$emit('done', entry);
    },
    close() {
      this.$emit('close', this.entry);
    },
  },
};
</script>

<style lang="scss">
@import "../cash-register.scss";
#modal-cash-register-receive {
  .cr-embedded-body {
    padding: 0;
  }
}
</style>
